import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _2a26929e = () => interopDefault(import('../pages/about-us/index.vue' /* webpackChunkName: "pages/about-us/index" */))
const _39155075 = () => interopDefault(import('../pages/blog/index.vue' /* webpackChunkName: "pages/blog/index" */))
const _f41988ba = () => interopDefault(import('../pages/contacts.vue' /* webpackChunkName: "pages/contacts" */))
const _3493b267 = () => interopDefault(import('../pages/privacy-policy.vue' /* webpackChunkName: "pages/privacy-policy" */))
const _e542f99c = () => interopDefault(import('../pages/index.vue' /* webpackChunkName: "pages/index" */))
const _41da08d7 = () => interopDefault(import('../pages/rules.vue' /* webpackChunkName: "pages/rules" */))
const _8a643a6e = () => interopDefault(import('../pages/shop/index.vue' /* webpackChunkName: "pages/shop/index" */))
const _421ea448 = () => interopDefault(import('../pages/technology.vue' /* webpackChunkName: "pages/technology" */))
const _539848ac = () => interopDefault(import('../pages/where-to-buy.vue' /* webpackChunkName: "pages/where-to-buy" */))
const _0a614592 = () => interopDefault(import('../pages/account/cart.vue' /* webpackChunkName: "pages/account/cart" */))
const _65180296 = () => interopDefault(import('../pages/account/change-password.vue' /* webpackChunkName: "pages/account/change-password" */))
const _30fdd090 = () => interopDefault(import('../pages/account/checkout.vue' /* webpackChunkName: "pages/account/checkout" */))
const _52446392 = () => interopDefault(import('../pages/account/dashboard.vue' /* webpackChunkName: "pages/account/dashboard" */))
const _69392603 = () => interopDefault(import('../pages/account/forgot-password.vue' /* webpackChunkName: "pages/account/forgot-password" */))
const _5d89ce32 = () => interopDefault(import('../pages/account/login.vue' /* webpackChunkName: "pages/account/login" */))
const _3cc2da82 = () => interopDefault(import('../pages/account/order-success.vue' /* webpackChunkName: "pages/account/order-success" */))
const _6a0551a7 = () => interopDefault(import('../pages/account/profile.vue' /* webpackChunkName: "pages/account/profile" */))
const _2a880295 = () => interopDefault(import('../pages/account/register.vue' /* webpackChunkName: "pages/account/register" */))
const _517fb26a = () => interopDefault(import('../pages/account/reset-password.vue' /* webpackChunkName: "pages/account/reset-password" */))
const _f93f202a = () => interopDefault(import('../pages/account/verify.vue' /* webpackChunkName: "pages/account/verify" */))
const _8d3702fc = () => interopDefault(import('../pages/account/orders/_id.vue' /* webpackChunkName: "pages/account/orders/_id" */))
const _554f2682 = () => interopDefault(import('../pages/about-us/_category/index.vue' /* webpackChunkName: "pages/about-us/_category/index" */))
const _3f6ea183 = () => interopDefault(import('../pages/blog/_category/index.vue' /* webpackChunkName: "pages/blog/_category/index" */))
const _44235ad7 = () => interopDefault(import('../pages/shop/_category/index.vue' /* webpackChunkName: "pages/shop/_category/index" */))
const _9e39dbd4 = () => interopDefault(import('../pages/about-us/_category/article/_article/index.vue' /* webpackChunkName: "pages/about-us/_category/article/_article/index" */))
const _172c7dd2 = () => interopDefault(import('../pages/blog/_category/article/_article/index.vue' /* webpackChunkName: "pages/blog/_category/article/_article/index" */))
const _cd9d51c4 = () => interopDefault(import('../pages/shop/_category/product/_product/index.vue' /* webpackChunkName: "pages/shop/_category/product/_product/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'active',
  scrollBehavior,

  routes: [{
    path: "/about-us",
    component: _2a26929e,
    name: "about-us___lv"
  }, {
    path: "/blog",
    component: _39155075,
    name: "blog___lv"
  }, {
    path: "/contacts",
    component: _f41988ba,
    name: "contacts___lv"
  }, {
    path: "/privacy-policy",
    component: _3493b267,
    name: "privacy-policy___lv"
  }, {
    path: "/ru",
    component: _e542f99c,
    name: "index___ru"
  }, {
    path: "/rules",
    component: _41da08d7,
    name: "rules___lv"
  }, {
    path: "/shop",
    component: _8a643a6e,
    name: "shop___lv"
  }, {
    path: "/technology",
    component: _421ea448,
    name: "technology___lv"
  }, {
    path: "/where-to-buy",
    component: _539848ac,
    name: "where-to-buy___lv"
  }, {
    path: "/account/cart",
    component: _0a614592,
    name: "account-cart___lv"
  }, {
    path: "/account/change-password",
    component: _65180296,
    name: "account-change-password___lv"
  }, {
    path: "/account/checkout",
    component: _30fdd090,
    name: "account-checkout___lv"
  }, {
    path: "/account/dashboard",
    component: _52446392,
    name: "account-dashboard___lv"
  }, {
    path: "/account/forgot-password",
    component: _69392603,
    name: "account-forgot-password___lv"
  }, {
    path: "/account/login",
    component: _5d89ce32,
    name: "account-login___lv"
  }, {
    path: "/account/order-success",
    component: _3cc2da82,
    name: "account-order-success___lv"
  }, {
    path: "/account/profile",
    component: _6a0551a7,
    name: "account-profile___lv"
  }, {
    path: "/account/register",
    component: _2a880295,
    name: "account-register___lv"
  }, {
    path: "/account/reset-password",
    component: _517fb26a,
    name: "account-reset-password___lv"
  }, {
    path: "/account/verify",
    component: _f93f202a,
    name: "account-verify___lv"
  }, {
    path: "/ru/about-us",
    component: _2a26929e,
    name: "about-us___ru"
  }, {
    path: "/ru/blog",
    component: _39155075,
    name: "blog___ru"
  }, {
    path: "/ru/contacts",
    component: _f41988ba,
    name: "contacts___ru"
  }, {
    path: "/ru/privacy-policy",
    component: _3493b267,
    name: "privacy-policy___ru"
  }, {
    path: "/ru/rules",
    component: _41da08d7,
    name: "rules___ru"
  }, {
    path: "/ru/shop",
    component: _8a643a6e,
    name: "shop___ru"
  }, {
    path: "/ru/technology",
    component: _421ea448,
    name: "technology___ru"
  }, {
    path: "/ru/where-to-buy",
    component: _539848ac,
    name: "where-to-buy___ru"
  }, {
    path: "/ru/account/cart",
    component: _0a614592,
    name: "account-cart___ru"
  }, {
    path: "/ru/account/change-password",
    component: _65180296,
    name: "account-change-password___ru"
  }, {
    path: "/ru/account/checkout",
    component: _30fdd090,
    name: "account-checkout___ru"
  }, {
    path: "/ru/account/dashboard",
    component: _52446392,
    name: "account-dashboard___ru"
  }, {
    path: "/ru/account/forgot-password",
    component: _69392603,
    name: "account-forgot-password___ru"
  }, {
    path: "/ru/account/login",
    component: _5d89ce32,
    name: "account-login___ru"
  }, {
    path: "/ru/account/order-success",
    component: _3cc2da82,
    name: "account-order-success___ru"
  }, {
    path: "/ru/account/profile",
    component: _6a0551a7,
    name: "account-profile___ru"
  }, {
    path: "/ru/account/register",
    component: _2a880295,
    name: "account-register___ru"
  }, {
    path: "/ru/account/reset-password",
    component: _517fb26a,
    name: "account-reset-password___ru"
  }, {
    path: "/ru/account/verify",
    component: _f93f202a,
    name: "account-verify___ru"
  }, {
    path: "/",
    component: _e542f99c,
    name: "index___lv"
  }, {
    path: "/ru/account/orders/:id?",
    component: _8d3702fc,
    name: "account-orders-id___ru"
  }, {
    path: "/account/orders/:id?",
    component: _8d3702fc,
    name: "account-orders-id___lv"
  }, {
    path: "/ru/about-us/:category",
    component: _554f2682,
    name: "about-us-category___ru"
  }, {
    path: "/ru/blog/:category",
    component: _3f6ea183,
    name: "blog-category___ru"
  }, {
    path: "/ru/shop/:category",
    component: _44235ad7,
    name: "shop-category___ru"
  }, {
    path: "/ru/about-us/:category?/article/:article",
    component: _9e39dbd4,
    name: "about-us-category-article-article___ru"
  }, {
    path: "/ru/blog/:category/article/:article",
    component: _172c7dd2,
    name: "blog-category-article-article___ru"
  }, {
    path: "/ru/shop/:category/product/:product",
    component: _cd9d51c4,
    name: "shop-category-product-product___ru"
  }, {
    path: "/about-us/:category",
    component: _554f2682,
    name: "about-us-category___lv"
  }, {
    path: "/blog/:category",
    component: _3f6ea183,
    name: "blog-category___lv"
  }, {
    path: "/shop/:category",
    component: _44235ad7,
    name: "shop-category___lv"
  }, {
    path: "/about-us/:category?/article/:article",
    component: _9e39dbd4,
    name: "about-us-category-article-article___lv"
  }, {
    path: "/blog/:category/article/:article",
    component: _172c7dd2,
    name: "blog-category-article-article___lv"
  }, {
    path: "/shop/:category/product/:product",
    component: _cd9d51c4,
    name: "shop-category-product-product___lv"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
